<h2 mat-dialog-title>{{title}}</h2>

<mat-dialog-content>
  {{content}}
</mat-dialog-content>

<mat-dialog-actions>
  @if (cancelButtonText) {
    <button
      mat-button
      mat-dialog-close
      color="accent"
      class="button">
      {{cancelButtonText}}
    </button>
  }
  @if (actionButtonText) {
    <button mat-flat-button
      [mat-dialog-close]="true"
      [color]="isDestructive ? 'warn' : 'accent'"
      class="button">
      {{actionButtonText}}
    </button>
  }
</mat-dialog-actions>
